var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "cancelConfirmTaskModal", role: "dialog", tabindex: "-1" },
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog modal-lg modal-dialog-centered" },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "p-4" }, [
              _c("h2", [_vm._v(_vm._s(_vm._f("trans")("Task Cancelled")))]),
              _vm._v(" "),
              _c("span", { staticClass: "font-size-125" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("trans")(
                      "Your Task has been successfully cancelled."
                    )
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn close-btn",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.close.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa fa-times mr-1" }),
                  _c("strong", [_vm._v(_vm._s(_vm._f("trans")("Close")))]),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }